var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.99 8C17.99 9.11208 17.1034 10 16 10C14.8923 10 14 9.10772 14 8C14 6.89228 14.8923 6 16 6C17.1034 6 17.99 6.88793 17.99 8ZM9.99 8C9.99 9.11208 9.10337 10 8 10C6.89229 10 6 9.10772 6 8C6 6.89228 6.89229 6 8 6C9.10337 6 9.99 6.88793 9.99 8ZM2 16.5C2 16.285 2.09978 16.0228 2.44404 15.7053C2.79514 15.3815 3.32938 15.0721 3.99778 14.8047C5.33619 14.2691 6.9599 14 8 14C9.0401 14 10.6638 14.2691 12.0022 14.8047C12.6706 15.0721 13.2049 15.3815 13.556 15.7053C13.9002 16.0228 14 16.285 14 16.5V18H2V16.5ZM18 16.5C18 15.5914 17.7584 14.7978 17.3618 14.1121C18.2113 14.2377 19.1629 14.4688 20.0022 14.8047C20.6706 15.0721 21.2049 15.3815 21.556 15.7053C21.9002 16.0228 22 16.285 22 16.5V18H18V16.5Z",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8b99b700683eaae7ec92171a6786a7dc.svg";
export { ForwardRef as ReactComponent };